module.exports = __webpack_public_path__ + "static/media/auto-icon.14998d37.svg";